/* eslint-disable camelcase */
import { useRouter } from 'next/router';
import get from 'base-ui/dist/underline/get';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

function useAbsImageUrl() {
  const router = useRouter();
  const wp_site_url = get(publicRuntimeConfig, 'wp_site_url', router?.pathname);
  const siteUrl = wp_site_url?.endsWith('/') ? publicRuntimeConfig.wp_site_url : `${publicRuntimeConfig.wp_site_url}/`;

  return (imageUrl) => {
    if (!imageUrl) return '/images/no-image_medium.png';

    let absImageUrl = imageUrl;
    if (!imageUrl.startsWith('http')) {
      absImageUrl = `${siteUrl}${imageUrl}`;
    }

    return absImageUrl;
  };
}

export default useAbsImageUrl;
